import { RecipesApi as RecipesOpenApiAPI } from 'service/openapi/__codegen__/apis/RecipesApi'
import { getConfiguration } from './getConfiguration'

export const RecipesApi: RecipesOpenApiAPI = new RecipesOpenApiAPI(getConfiguration())
